import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueSignaturePad from 'vue-signature-pad';
import './registerServiceWorker'

// Importar la configuración personalizada de Vuetify (reemplazaremos el archivo existente)
import vuetify from './plugins/vuetify';

// Importar estilos globales de Google
import './assets/styles/google-theme.css';

Vue.use(VueSignaturePad);
Vue.config.productionTip = false

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')

// Exponer router globalmente para manejos de redirección desde utilidades
if (typeof window !== 'undefined') {
    window.appRouter = router;
}